<div class="content">
  <div class="header">
    <div class="title">
      {{ 'Switch call to this device?' | translate }}
    </div>

    <app-pencil-button
      class="pencil-button white"
      [icon]="'close'"
      [iconConfig]="{
        type: IconTypes.matIcon,
        wrapperStyle: { 'font-size': '20px' }
      }"
      (click)="onClose()"
      *ngIf="(uiService.isMobile | async) == false"
    >
    </app-pencil-button>
  </div>

  <div class="body">
    <div class="container">
      <p>
        {{
          'You have already joined this call on another device. Want to join here instead?'
            | translate
        }}
        <a
          class="link"
          (click)="
            onOpenLink(
              'https://intercom.help/pencil/en/articles/8889401-can-i-join-the-same-call-from-multiple-devices'
            )
          "
          >{{ ' Learn More' | translate }}
        </a>
      </p>

      <div class="actions">
        <app-pencil-button
          class="pencil-button light"
          [class.large]="uiService.isMobile | async"
          [label]="'Join call here' | translate"
          [icon]="'phone_callback'"
          (click)="onJoinCall()"
        >
        </app-pencil-button>

        <app-pencil-button
          class="pencil-button primary"
          [class.large]="uiService.isMobile | async"
          [label]="'Not now' | translate"
          [icon]="'close'"
          [iconConfig]="{
            type: IconTypes.matIcon
          }"
          (click)="onClose()"
        >
        </app-pencil-button>
      </div>
    </div>
  </div>
</div>
